var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('md-button',{class:_vm.buttonClass,attrs:{"disabled":_vm.disabled},on:{"click":_vm.action}},[_c('md-tooltip',[_vm._v(_vm._s(_vm.type))]),_c('md-icon',[_vm._v(_vm._s(_vm.buttonIcon))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }